/* eslint-disable max-len */
import englishMessages from "ra-language-english";
import vietnameseMessages from "ra-language-vietnamese";

export const customEnglishMessages = {
  ra: {
    ...englishMessages.ra,
    action: {
      ...englishMessages.ra.action,
      clear_array_input: "Clear Input"
    },
    message: {
      ...englishMessages.ra.message,
      clear_array_input: "Clear Input"
    },
    choices: {
      PAY_FULL_UPFRONT: "Pay Full Upfront",
      PAY_IN_STORE: "Pay In Store",
      BASIC: "Basic",
      LIMITED: "Limited",
      FULL: "Full"
    }
  },
  pagenames: {
    home: "Home",
    companies: "Companies",
    locations: "Locations",
    amenities: "Amenities",
    platform: "Plaform Settings",
    users: "Users",
    availability: "Availability",
    services: "Services",
    addons: "Add Ons",
    menusections: "Menu Sections",
    menus: "Menus",
    appointmentservices: "Appointment Services",
    appointment: "Appointment",
    artists: "Artists",
    equipment: "Equipment",
    appointment_order: "Appointment Order",
    walk_in_order: "Walk In Order",
    orders_list: "Orders List",
    customers: "Customers",
    staff: "Staff",
    artist_exclusions: "Artist Exclusions",
    appointments_list: "Appointments list",
    credits: "Credits",
    order: "Order",
    artist: "Artist",
    location: "Location",
    menu: "Menu",
    service: "Service",
    add_on: "Add-on"
  },
  companies: {
    name: "Name",
    is_verified: "Verified",
    status: "Plan",
    company_verify: "Verify Company",
    owner: "Owner",
    caption: "Caption",
    about: "About",
    cover_photo: "Cover Photo",
    cover_photo_url: "Current Cover Photo",
    logo: "Logo",
    logo_url: "Current Logo",
    timeslot_spacing: "Timeslot Spacing",
    late_cancellation_hours: "Late Cancellation Hours",
    late_cancellation_charge: "Late Cancellation Charge",
    no_show_charge: "No Show Charge",
    payment_type: "Payment Type",
    payment_method: "Payment Method",
    facebook_url: "Facebook URL",
    instagram_url: "Instagram URL",
    twitter_url: "Twitter URL",
    website_url: "Website URL",
    amenities: "Amenities",
    default_service: "Default Service",
    retail_tax_rate: "Retail Tax Rate",
    contact_email: "Contact Email",
    company: "Company",
    company_details: "Company details",
    export_companies: "Export Companies",
    created_from: "Created from",
    created_to: "Created to",
    created_date_range_invalid: "End date must be after start date",
    login_as_owner: "Login as Owner",
    cover_image_recommended: "Cover image (Recommended dimension 1440x480)",
    finish_onboarding_stripe: "Finish Onboarding Stripe",
    connect_stripe: "Connect Stripe",
    refresh: "Refresh",
    stripe_account_connected_charges_enabled:
      "Your Stripe account is connected, and charges are enabled.",
    view_company_page: "View Company Page",
    user_pays_fees: "Customers pay merchant processing fees",
    pointment_pricing: "Pointment pricing",
    get_a_software_system:
      "Get a software system that runs your whole salon for price of one mani/pedi!",
    slash_month: "/month",
    fee: "Fee",
    free: "Free",
    salon_profile_page_and_menu: "Salon Profile Page & Menu",
    customer_booking: "Customer Booking",
    admin_calendar: "Admin Calendar",
    staffing: "Staffing",
    payment_processing: "Payment Processing",
    inventory_management: "Inventory Management",
    customer_data: "Customer Data",
    select_basic_plan: "Select Basic Plan",
    select_limited_plan: "Select Limited Plan",
    select_full_plan: "Select Full Plan",
    change_a_plan: "Change a plan",
    selected_plan: "Selected plan",
    billing_information: "Billing information",
    save_and_continue: "Save and Continue",
    billing_address: "Billing Address",
    cancel_plan: "Cancel Plan",
    renew_plan: "Renew Plan",
    payment_method_required_to_renew:
      "Payment method is required to renew the subscription",
    active_until: "Subscription is active until",
    next_payment_on: "Next payment will be on",
    please_enter_payment_method_and_billing_address_to_renew:
      "Please enter a payment method and billing address to renew this subscription",
    please_enter_your_billing_address_to_renew:
      "Please enter your billing address to renew this subscription",
    please_enter_your_preferred_payment_method_to_renew:
      "Please enter your preferred payment method to renew this subscription",
    to_upgrade_to_a_paid_plan_please:
      "To upgrade to a paid plan, please add a payment method and billing address.",
    a_payment_method_and_billing_address_are_required_to_change_this_plan:
      "A payment method and billing address are required to change this plan",
    a_billing_address_is_required_to_change_this_plan:
      "A billing address is required to change this plan",
    a_payment_method_is_required_to_change_this_plan:
      "A payment method is required to change this plan",
    do_you_want_to_give_dynamic_day_days_free_trial_to_this_company:
      "Do you want to give {dynamic_day} days free trial to this company?",
    give_free_trial_prefix: "Do you want to give",
    give_free_trial_suffix: "days free trial to this company?",
    are_you_sure_you_want_to_cancel_the_plan_this_action_cannot_be_undone:
      "Are you sure you want to cancel the plan? This action cannot be undone.",
    yes_cancel: "Yes, cancel",
    basic_to_full_without_appointments:
      "Are you sure you want to upgrade from BASIC to FULL? First-time upgrades will start a 90-day FREE trial of the FULL plan. Returning upgrades will start a new billing cycle immediately upon upgrade.",
    basic_to_limited_without_appointments:
      "Are you sure you want to upgrade from BASIC to LIMITED? Upgrade will take effect immediately, and Pointments processed on the platform will be charged a 10% commission fee.",
    limited_to_full_with_appointments:
      "Are you sure you want to upgrade from LIMITED to FULL? First-time upgrades will start a 90-day FREE trial of the FULL plan. Returning upgrades will start a new billing cycle immediately upon upgrade.",
    limited_to_full_without_appointments:
      "Are you sure you want to upgrade from LIMITED to FULL? First-time upgrades will start a 90-day FREE trial of the FULL plan. Returning upgrades will start a new billing cycle immediately upon upgrade.",
    limited_to_basic_with_appointments:
      "Are you sure want to downgrade from LIMITED to BASIC?",
    limited_to_basic_without_appointments:
      "Are you sure want to downgrade from LIMITED to BASIC?",
    full_to_limited_with_appointments:
      "Are you sure you want to change your plan from FULL to LIMITED? Your current billing cycle ends on [DATE]. By downgrading your plan today, you'll still have full access until the end of the current billing period. After [DATE] your subscription will downgrade and you will lose access to the calendar, future appointment data, and customer information. Pointments on the LIMITED plan will be charged a 10% commission fee.",
    full_to_limited_without_appointments:
      "Are you sure you want to change your plan from FULL to LIMITED? Your current billing cycle ends on [DATE]. By downgrading your plan today, you'll still have full access until the end of the current billing period. After [DATE] your subscription will downgrade and you will lose access to the calendar, future appointment data, and customer information. Pointments on the LIMITED plan will be charged a 10% commission fee.",
    full_to_basic_with_appointments:
      "Are you sure you want to change your plan from FULL to BASIC? Your current billing cycle ends on [DATE]. By downgrading your plan today, you'll still have full access until the end of the current billing period. After [DATE] your subscription will downgrade and you will lose access to all calendars, future appointment data, and customer information.",
    full_to_basic_without_appointments:
      "Are you sure you want to change your plan from FULL to BASIC? Your current billing cycle ends on [DATE]. By downgrading your plan today, you'll still have full access until the end of the current billing period. After [DATE] your subscription will downgrade and you will lose access to all calendars, future appointment data, and customer information.",
    basic_cancel_without_appointments:
      "Your current billing cycle ends on [DATE]. If you cancel today, you’ll still have full access until the end of the current billing period. After [DATE], your plan will not renew and access will end. You will no longer be visible on the Pointment website or app. Are you sure you want to cancel today?",
    limited_cancel_with_appointments:
      "Are you sure you want to cancel your LIMITED plan? After your last appointment you will no longer have access to your calendar or be visible on the Pointment website or app.",
    limited_cancel_without_appointments:
      "Are you sure you want to cancel your LIMITED plan? After your last appointment you will no longer have access to your calendar or be visible on the Pointment website or app.",
    full_cancel_with_appointments:
      "Your current billing cycle ends on [DATE]. If you cancel today, you’ll still have full access until the end of the current billing period. After [DATE], your plan will not renew and access will end. You will lose visibility to all calendars, future appointment data, and customer information. Are you sure you want to cancel today?",
    full_cancel_without_appointments:
      "Your current billing cycle ends on [DATE]. If you cancel today, you’ll still have full access until the end of the current billing period. After [DATE], your plan will not renew and access will end. You will lose visibility to all calendars, future appointment data, and customer information. Are you sure you want to cancel today?",
    select_basic_plan_cc_info:
      "Please note that credit card entry is required for all Pointment salon accounts. Your card will not be charged until your account is verified by Pointment, and your 60 day free trial is complete. You can cancel your plan at any time.",
    select_limited_plan_cc_info:
      "Please note that credit card entry is required for Pointment salon accounts selecting the LIMITED plan, but your card will not be charged. A 10% fee will be collected for all Pointments completed on the LIMITED plan. This collection will be deducted from your earnings on Pointment.",
    select_full_plan_cc_info:
      "Please note that credit card entry is required for Pointment salon accounts selecting the FULL plan. Your card will not be charged until your account is verified by Pointment and your 90-day free trial is complete. You can cancel your plan at any time.",
    choose_the_pointment_subscription_plan:
      "Choose the Pointment subscription plan that fits your business best. You can upgrade, change, or cancel your plan at any time. FULL plan includes your first three months free!",
    choose_the_pointment_subscription_plan_edit:
      "Choose the Pointment subscription plan that fits your business best. You can upgrade, change, or cancel your plan at any time.",
    curious_how_each_plan_works_schedule_a_live:
      "Curious to see how each plan works? Schedule a live",
    demo: "demo",
    or_click: "or click",
    here: "here",
    to_learn_more: "to learn more",
    start_free_trial: "Start Free Trial",
    free_for: "Free for",
    ninety_days: "90 days"
  },
  locations: {
    company: "Company Name",
    name: "Display Name",
    nickname: "Nickname",
    menu: "Menu",
    timezone: "Timezone",
    amenity: "Amenity",
    amenities: "Amenities",
    facebook_url: "Facebook URL",
    instagram_url: "Instagram URL",
    twitter_url: "Twitter URL",
    website_url: "Website URL",
    description: "Description",
    cover_photo: "Cover Photo",
    current_cover_photo: "Current Cover Photo",
    multi_person: "Multi-person",
    hours: "Hours",
    monday: "monday",
    tuesday: "tuesday",
    wednesday: "wednesday",
    thursday: "thursday",
    friday: "friday",
    saturday: "saturday",
    sunday: "sunday",
    open: "Open",
    close: "Close",
    phone_number: "Phone Number",
    sms_phone_number: "SMS Phone Number",
    send_sms: "Send SMS",
    visible_on_homepage: "Visible on Homepage",
    visible_on_homepage_helper: "(Company must be verified by Pointment)",
    location_details: "Location details",
    view_location_page: "View Location Page",
    address: "Address"
  },
  platform: {
    contact_email: "Contact Email",
    amount_billed_per_appointment: "Amount Billed Per Appointment",
    service_price_per_month: "Service Price Per Month",
    percent_billed_from_pos: "Percent Billed From PO",
    appointment_reminder_hours_before: "Appointment Reminder Hours Before",
    approved_emails: "Approved Emails",
    feature_flag_restricted_sign_up: "Restricted Sign Up",
    platform_settings: "Platform Settings",
    platform_settings_details: "Platform Settings details"
  },
  amenities: {
    name: "Name",
    type: "Type",
    logo_url: "Logo"
  },
  users: {
    first_name: "First name",
    last_name: "Last name",
    profile_photo: "Profile Photo",
    current_profile_photo: "Current Profile Photo",
    company: "Company Name",
    phone_number: "Phone Number",
    birthday: "Birthday",
    stripe_customer_id: "Stripe Customer ID",
    pronoun: "Pronoun",
    role: "Role",
    customer: "Customer",
    email: "Email",
    birthdate: "Birthdate",
    description: "Description",
    appointments: "Appointments",
    this_email_has_already_been_registered:
      "This email has already been registered.",
    registered: "Registered",
    search: "Search",
    refunds: "Credits",
    customer_details: "Customer details",
    create_an_order: "Create an Order",
    saved_credit_cards: "Saved credit cards",
    advanced_details: "Advanced details",
    no_credits: "No Credits",
    no_appointment_yet: "No Appointment yet",
    birthday_optional: "Birthday (Optional)",
    has_logged_in: "Has Logged In",
    resend_invite: "No - Resend Invite",
    resend_invite_disabled: "Resend In",
    change_email_contact: "To change your email, contact us at",
    notification_settings_title: "Notification settings",
    promotional: "promotional",
    no_email: "No email on file",
    no_phone_number: "No phone number on file",
    notification_email: "Contact Email",
    notification_sms: "Contact SMS",
    notification_promo_email: "Promotional email",
    notification_promo_sms: "Promotional SMS",
    contact: "Contact",
    on: "on",
    off: "off"
  },
  artists: {
    bio: "Bio",
    cover_photo: "Cover Photo",
    rating_aggregate: "Rating Aggregate",
    status: "Status",
    technicians: "Technicians",
    role: "Role",
    exclude: "Exclude",
    artist_profile_photo: "Artist profile photo",
    create: "Create",
    artist_details: "Artist details",
    already_authorized_instagram_account:
      "You have already authorized your Instagram account.",
    active: "Active"
  },
  availability: {
    title: "Title",
    date: "Date",
    start: "Start",
    end: "End",
    end_recurrence: "End Recurrence",
    location: "Location",
    artist: "Artist",
    event_type: "Event Type",
    event_type_availability: "Availability",
    repeat: "Repeat Options",
    delete_recurrence: "Delete Recurring Availabilities",
    new_availability: "New Availability",
    create_availability: "Create availability",
    edit_availability: "Edit availability"
  },
  services: {
    name: "Name",
    company: "Company",
    description: "Description",
    duration: "Duration",
    formatted_name: "Formatted Name",
    logo: "Logo",
    photo_1: "Photo 1",
    photo_2: "Photo 2",
    photo_3: "Photo 3",
    photo_4: "Photo 4",
    photo_5: "Photo 5",
    price: "Price",
    special_conditions: "Special Conditions",
    facilities: "Equipment",
    menu_sections: "Menu Sections",
    clean_up_time: "Clean Up Time",
    category: "Category",
    scheduling_priority: "Scheduling Priority",
    choice_is_required: "Choice is required",
    service_details: "Service details",
    add_on_details: "Add-on details",
    gallery_up_to_5_images: "Gallery (up to 5 images)",
    enable: "Enable",
    disable: "Disable"
  },
  common: {
    name: "Name",
    company: "Company",
    user: "User",
    description: "Description",
    edit: "Edit",
    show: "Show",
    export_to_csv: "Export to CSV",
    select_date: "Select Date",
    sort_by: "Sort by",
    details: "Details",
    more: "More",
    add_ons: "Add-ons",
    cancellation_confirmation: "Cancellation Confirmation",
    no_go_back: "No, Go Back",
    yes_but_do_not_charge: "Yes, but don't charge",
    yes_but_do_not_give_credits: "Yes, but don't give credits",
    yes: "Yes",
    yes_cancel: "Yes, cancel",
    created_at: "Created At",
    updated_at: "Updated At",
    no: "No",
    view_details: "View details",
    locations: "Locations",
    add_filters: "Add Filters",
    reset_all: "Reset all",
    start_time: "Start time",
    end_time: "End time",
    "appointment.start_time": "Appointment start time",
    all_locations: "All Locations",
    day_view: "Day view",
    week_view: "Week view",
    month_view: "Month view",
    cancel: "Cancel",
    done: "Done",
    today: "Today",
    last_week: "Last Week",
    this_week: "This Week",
    next_week: "Next Week",
    last_7_days: "Last 7 Days",
    next_7_days: "Next 7 Days",
    this_month: "This Month",
    next_month: "Next Month",
    clear_filters: "Clear Filters",
    save: "Save",
    saving: "Saving",
    set_photo: "Set photo",
    please_wait: "Please wait",
    we_are_loading_data: "We are loading data",
    remove: "Remove",
    set_logo: "Set logo",
    set_image: "Set image",
    undo: "Undo",
    something_went_wrong: "Something went wrong",
    delete: "Delete"
  },
  cancellation_modal: {
    customer_already_paid: "The customer has already paid $%{amount}.",
    customer_not_paid_yet: "The customer has not paid yet.",
    fee_will_be_charged:
      "After applying a %{window} cancellation fee of $%{fee}, the customer will incur $%{total} charge.",
    fee_will_be_credited_back:
      "After applying a %{window} cancellation fee of $%{fee}, the customer will be given $%{credits} back.",
    are_you_sure_to_cancel: "Are you sure you want to cancel?",
    are_you_sure_to_cancel_appointment:
      "Are you sure you want to cancel this appointment?",
    late_cancelation_warning:
      "This cancelation request is within 12 hours of the appointment's scheduled start time. By canceling, the customer will still be required to pay the full appointment fee. Are you sure you want to cancel this appointment?",
    yes_waive_fees_refund: "Yes, but waive the fees and refund $%{amount}",
    fees_waived_refund_message:
      "The fees will be waived. The customer will be refunded $%{amount}.",
    fee_applied_refund_message:
      "After applying a %{window} cancellation fee of $%{fee}, the customer will be refunded $%{amount}.",
    will_refund_message: "The customer will be refunded $%{amount}.",
    how_to_refund_explanation:
      "How would you like to refund the customer? Store credits are added instantly. Refunds to the original payment method may take 5–10 business days.",
    refund_to_original_button: "Refund $%{amount} to original payment method",
    give_store_credits_button: "Give $%{amount} in store credits",
    late_window: "late",
    no_show_window: "no-show"
  },
  menusections: {
    order: "Order",
    section_name: "Section Name",
    menu_details: "Menu details",
    add_menu_section: "Add Menu Section"
  },
  appointmentservices: {
    name: "Name",
    company: "Company",
    user: "User",
    person_number: "Person Number",
    service: "Service",
    order: "Order",
    person_name: "Person Name",
    appointment: "Appointment",
    artist: "Artist"
  },
  appointment: {
    user: "User",
    customer: "Customer",
    inserted_by: "Inserted By",
    start_time: "Starts",
    end_time: "Ends",
    location: "Location",
    service: "Service",
    services: "Services",
    location_name: "Location Name",
    created_at: "Created At",
    updated_at: "Updated At",
    checked_in_at: "Checked in at",
    confirmed_at: "Confirmed at",
    cancelled_at: "Cancelled at",
    appointment_services: "Appointment Services",
    notes: "Notes",
    check_in: "Check In",
    check_out: "Check Out",
    services_completed: "Services Completed",
    cancel: "Cancel",
    completed_at: "Completed at",
    charge: "Charge",
    artists: "Artist",
    rescheduled_at: "Rescheduled at",
    today: "Today",
    checked_in: "Checked in",
    order: "Order",
    start_end_time: "Start & End Time",
    cancelled: "Cancelled",
    reschedule: "Reschedule",
    order_details: "Order Details",
    checked_out: "Checked out",
    appointment_details: "Appointment details",
    log: "Log",
    date: "Date",
    persons: "Persons",
    status: "Status",
    in_progress: "In progress",
    upcoming: "Upcoming",
    completed: "Completed",
    rescheduled: "Rescheduled",
    time: "Time",
    client: "Client",
    note: "Note",
    appointment_note: "Appointment note",
    service_and_add_ons: "Service and add-ons",
    start_date_and_time: "Start date & time",
    create_pointment: "Create Pointment",
    select_customer: "Select customer",
    customers: "Customers",
    search_by_phone: "Search by Phone",
    new_customer: "New Customer",
    search: "Search",
    general_details: "General details",
    select_services: "Select services",
    section: "Section",
    addons: "Add-ons",
    add: "Add",
    added: "Added",
    total_price: "Total Price",
    total_duration: "Total Duration",
    please_select_the_location_first:
      "Please select the location first in the general details section",
    you_need_to_fill_required_fields: "You need to fill required fields",
    no_existing_customer_found:
      "No existing customer found with searched number",
    existing_customer_selected:
      "%{name} already exists with this phone number and has been selected",
    at_least_one_service: "At least one service must be selected",
    got_it: "Got it",
    fees_not_included: "Fees not included",
    clean_up_time_not_included: "Clean up time not included",
    search_to_find_customers: "Search to find customers",
    blocked_time: "Blocked Time",
    client_phone_number: "Client phone number",
    cancel_full_appointment: "Cancel full appointment",
    client_details: "Client details",
    this_artist_was_specified_by_customer:
      "This artist was specified by customer",
    moved_at: "Moved at"
  },
  facility: {
    name: "Name",
    capacity: "Capacity",
    location: "Location",
    services: "Services",
    facility_services: "Equipment Services"
  },
  order: {
    user: "User",
    appointment: "Appointment",
    artist: "Artist",
    status: "Status",
    created_at: "Created At",
    updated_at: "Updated At",
    amount: "Amount",
    transactions: "Transactions",
    tx_services: "Transaction Services",
    finish_order: "Finish Order",
    refunded_at: "Refunded At",
    tip_amount: "Tip Amount",
    final_amount: "Final amount",
    amount_captured: "Amount captured",
    tips_captured: "Tips captured",
    payment_status: "Payment Status",
    charge: "Charge",
    add_to_order: "Add to order",
    create_order: "Create order",
    export_to_pdf: "Export order to .PDF",
    refund: "Refund",
    refunded: "Refunded",
    refund_funds: "Refund funds",
    maximum_refundable: "Maximum refundable",
    refund_amount_exceeds_max: "Amount exceeds maximum refundable amount",
    refund_amount_load_error: "Failed to load refundable amount",
    refund_submit_error: "Failed to refund transaction",
    refund_success: "Refund issued",
    cancel: "Cancel",
    cancelled: "Cancelled",
    order_details: "Order Details",
    item: "Item",
    price: "Price",
    quantity: "Quantity",
    method: "Method",
    type: "Type",
    tips: "Tips",
    what_to_add: "What to add",
    description: "Description",
    services: "Services",
    service: "Service",
    addon: "Add On",
    freeform: "Freeform",
    locations: "Locations",
    location: "Location",
    add_arbitary_credits: "Refund store credits",
    where_to_add: "Where to add",
    subtotal: "Subtotal",
    tax_and_fees: "Tax & Fees",
    discount: "Discount",
    total: "Total",
    add_service: "Add Service",
    add_add_on: "Add Add-On",
    add_freeform: "Add Freeform",
    add_discount: "Add Discount",
    edit_order: "Edit Order",
    walk_in: "Walk-in",
    amount_required: "Amount Required",
    total_amount: "Total Amount",
    tip: "Tip"
  },
  empty_list: {
    do_you_want_to_add_one: "Do you want to add one?",
    no_customers_yet: "No customers yet.",
    add_a_customer: "Add a customer",
    no_appointments_yet: "No appointments yet.",
    no_appointments_were_found: "No appointments were found.",
    no_orders_yet: "No orders yet.",
    no_equipment_yet: "No equipment yet.",
    add_an_equipment: "Add equipment",
    no_menus_yet: "No menus yet.",
    add_a_menu: "Add a menu",
    no_services_yet: "No services yet.",
    no_addons_yet: "No add ons yet.",
    add_a_service: "Add a service",
    add_a_addon: "Add an add on",
    no_locations_yet: "No locations yet.",
    add_a_location: "Add a location",
    no_staff_members_yet: "No staff members yet.",
    add_a_member: "Add a member",
    no_artists_yet: "No artists yet.",
    no_results_found: "No results were found for this date."
  },
  navigation: {
    Dashboard: "Dashboard",
    Schedule: "Schedule",
    Customers: "Customers",
    Users: "Users",
    System: "System",
    Charge: "Charge",
    Staff: "Staff",
    Salon: "Salon",
    Availability: "Availability",
    Appointment: "Appointment",
    appointment_calendar: "Appointment Calendar",
    services_calendar: "Services Calendar",
    Companies: "Companies",
    platform_settings: "Platform Settings",
    appointment_orders: "Appointment Orders",
    walk_in_orders: "Walk-in Orders",
    Company: "Company",
    Location: "Location",
    Menus: "Menus",
    "Appointment Services": "Appointment Services",
    Reporting: "Reporting",
    Tipping: "Tipping",
    Orders: "Orders",
    Transactions: "Transactions",
    "Cancelled Appointments": "Cancelled Appointments",
    Services: "Services",
    AddOns: "Add Ons",
    Equipment: "Equipment",
    Support: "Support",
    Version: "Version",
    log_out: "Log out",
    English: "English",
    Vietnamese: "Vietnamese",
    new_charge: "New Charge"
  },
  refund: {
    amount: "Amount",
    consumed: "Consumed",
    not_consumed: "Not Consumed",
    appointment: "Appointment",
    take_away: "Take Away Credit"
  },
  report: {
    appointment_services: "Appointment Services",
    date: "Date",
    time: "Time",
    artist: "Artist",
    service: "Service",
    customer_name: "Customer Name",
    location: "Location",
    amount: "Amount",
    is_fully_paid: "Is Fully Paid",
    order_id: "Order ID",
    artist_name: "Artist Name",
    artist_id: "Artist ID",
    appointment_date: "Appointment Date",
    appointment_description: "Appointment Description",
    tip_amount: "Tip Amount",
    tipping: "Tipping",
    transactions: "Transactions",
    cancelled_appointments: "Cancelled Appointments",
    appointment_id: "Appointment ID",
    location_id: "Location ID",
    cancelled_at: "Cancelled At",
    was_rescheduled: "Was Rescheduled",
    cancellation_type: "Cancellation Type",
    transaction_id: "Transaction ID",
    transaction_type: "Transaction Type",
    transaction_refund_capture: "Transaction Refund Capture",
    transaction_date_time: "Transaction Date Time",
    transaction_tip_amount: "Transaction Tip Amount",
    transaction_services_total: "Transaction Services Total",
    transaction_user_pays_fees: "Transaction User Pays Fees",
    transaction_payment_fees_percent: "Transaction Payment Fees Percent",
    transaction_payment_fees: "Transaction Payment Fees",
    transaction_total: "Transaction Total",
    location_name: "Location Name",
    stripe_id: "Stripe ID",
    status: "Status",
    transaction_description: "Transaction Description",
    appointment_date_time: "Appointment Date Time",
    total: "Total",
    payout: "Payout",
    cc_payout: "CC Payout"
  },
  dashboard: {
    dashboard: "Dashboard",
    no_data_yet: "No data yet",
    sales: "Sales",
    services: "Services",
    tips: "Tips",
    customers: "Customers",
    new: "New",
    recurring: "Recurring",
    completed: "Completed",
    upcoming: "Upcoming",
    customer: "Customer",
    service: "Service",
    artist: "Artist",
    starts: "Starts",
    you: "You",
    today: "Today",
    total: "Total"
  }
};

export const customVietnameseMessages = {
  ra: {
    ...vietnameseMessages.ra,
    action: {
      ...vietnameseMessages.ra.action,
      clear_array_input: "Xóa đầu vào"
    },
    message: {
      ...vietnameseMessages.ra.message,
      clear_array_input: "Xóa đầu vào"
    },
    choices: {
      PAY_FULL_UPFRONT: "Trả trước đầy đủ",
      PAY_IN_STORE: "Thanh toán tại cửa hàng"
    },
    sort: {
      ASC: "ASC",
      DESC: "DESC"
    }
  },
  pagenames: {
    home: "Nhà",
    companies: "Các công ty",
    locations: "Vị trí",
    amenities: "Tiện nghi",
    platform: "Nền tảng",
    users: "Người dùng",
    availability: "Khả dụng",
    services: "Dịch vụ",
    addons: "Thêm vào",
    menusections: "thực đơn tiết diện",
    menus: "Thực đơn",
    appointmentservices: "Dịch vụ hẹn giờ",
    appointment: "Cuộc hẹn",
    artists: "Nghệ sĩ",
    equipment: "Thiết bị",
    appointment_order: "Đặt hàng cuộc hẹn",
    walk_in_order: "Đặt hàng bước vào",
    orders_list: "Danh sách đơn hàng",
    customers: "Khách hàng",
    staff: "Nhân viên",
    artist_exclusions: "Nghệ sĩ loại trừ",
    appointments_list: "danh sách cuộc hẹn",
    credits: "Tín dụng",
    order: "Đặt hàng",
    artist: "Nghệ sĩ",
    location: "Vị trí",
    menu: "Thực đơn",
    service: "Dịch vụ",
    add_on: "Thêm vào"
  },
  companies: {
    name: "Tên",
    is_verified: "Đã xác minh",
    status: "Kế hoạch",
    company_verify: "Xác minh công ty",
    owner: "Người sở hữu",
    caption: "Đầu đề",
    about: "Về",
    cover_photo: "Ảnh bìa",
    cover_photo_url: "Ảnh bìa hiện tại",
    logo: "Logo",
    logo_url: "Biểu trưng hiện tại",
    timeslot_spacing: "Khoảng cách giữa các khoảng thời gian",
    late_cancellation_hours: "Hủy trễ giờ",
    late_cancellation_charge: "Phí hủy trễ",
    no_show_charge: "Phí không hiển thị",
    payment_method: "Phương thức thanh toán",
    payment_type: "Loại thanh toán",
    facebook_url: "Facebook URL",
    instagram_url: "Instagram URL",
    twitter_url: "Twitter URL",
    website_url: "Website URL",
    amenities: "Tiện nghi",
    default_service: "Dịch vụ mặc định",
    retail_tax_rate: "Tỷ lệ thuế bán lẻ",
    contact_email: "Liên hệ Email",
    company: "Công ty",
    company_details: "Chi tiết công ty",
    export_companies: "Xuất công ty",
    created_from: "Được tạo từ",
    created_to: "Được tạo đến",
    created_date_range_invalid: "Ngày kết thúc phải sau ngày bắt đầu",
    login_as_owner: "Đăng nhập với tư cách chủ sở hữu",
    cover_image_recommended: "Ảnh bìa (Kích thước khuyến nghị 1440x480)",
    finish_onboarding_stripe: "Kết thúc quá trình giới thiệu Stripe",
    connect_stripe: "Kết nối Stripe",
    refresh: "Làm cho khỏe lại",
    stripe_account_connected_charges_enabled:
      "Tài khoản Stripe của bạn đã được kết nối và các khoản phí được bật.",
    view_company_page: "Xem trang công ty",
    user_pays_fees: "Khách hàng trả phí xử lý của thương nhân",
    pointment_pricing: "Định giá điểm",
    get_a_software_system:
      "Nhận một hệ thống phần mềm điều hành toàn bộ salon của bạn với giá của một lần mani/pedi!",
    slash_month: "/tháng",
    fee: "Phí",
    free: "Miễn phí",
    salon_profile_page_and_menu: "Trang hồ sơ salon & Thực đơn",
    customer_booking: "Đặt chỗ khách hàng",
    admin_calendar: "Lịch quản trị",
    staffing: "Nhân sự",
    payment_processing: "Xử lý thanh toán",
    inventory_management: "Quản lý hàng tồn kho",
    customer_data: "Dữ liệu khách hàng",
    select_basic_plan: "Chọn gói cơ bản",
    select_limited_plan: "Chọn gói hạn chế",
    select_full_plan: "Chọn gói đầy đủ",
    change_a_plan: "Thay đổi gói",
    selected_plan: "Gói đã chọn",
    billing_information: "Thông tin thanh toán",
    save_and_continue: "Lưu và Tiếp tục",
    billing_address: "Địa chỉ thanh toán",
    cancel_plan: "Hủy gói",
    renew_plan: "Gia hạn gói",
    payment_method_required_to_renew:
      "Phương thức thanh toán là bắt buộc để gia hạn gói",
    active_until: "Gói đã được gia hạn",
    next_payment_on: "Thanh toán tiếp theo sẽ được thanh toán vào",
    please_enter_payment_method_and_billing_address_to_renew:
      "Vui lòng nhập phương thức thanh toán và địa chỉ thanh toán để gia hạn đăng ký này",
    please_enter_your_billing_address_to_renew:
      "Vui lòng nhập địa chỉ thanh toán của bạn để gia hạn đăng ký này",
    please_enter_your_preferred_payment_method_to_renew:
      "Vui lòng nhập phương thức thanh toán ưa thích của bạn để gia hạn đăng ký này",
    to_upgrade_to_a_paid_plan_please:
      "Để nâng cấp lên gói trả phí, vui lòng thêm phương thức thanh toán và địa chỉ thanh toán.",
    a_payment_method_and_billing_address_are_required_to_change_this_plan:
      "Phương thức thanh toán và địa chỉ thanh toán là bắt buộc để thay đổi gói này",
    a_billing_address_is_required_to_change_this_plan:
      "Một địa chỉ thanh toán là bắt buộc để thay đổi gói này",
    a_payment_method_is_required_to_change_this_plan:
      "Một phương thức thanh toán là bắt buộc để thay đổi gói này",
    do_you_want_to_give_dynamic_day_days_free_trial_to_this_company:
      "Bạn có muốn tặng {dynamic_day} ngày dùng thử miễn phí cho công ty này không?",
    give_free_trial_prefix: "Bạn có muốn tặng",
    give_free_trial_suffix: "ngày dùng thử miễn phí cho công ty này không?",
    are_you_sure_you_want_to_cancel_the_plan_this_action_cannot_be_undone:
      "Bạn có chắc chắn muốn hủy gói này không? Hành động này không thể hoàn tác.",
    yes_cancel: "Có, hủy",
    basic_to_full_without_appointments:
      "Bạn có chắc muốn nâng cấp từ BASIC lên FULL không? Các lượt nâng cấp lần đầu sẽ bắt đầu bản dùng thử MIỄN PHÍ 90 ngày của gói FULL. Các lượt nâng cấp lại sẽ bắt đầu chu kỳ thanh toán mới ngay sau khi nâng cấp.",
    basic_to_limited_without_appointments:
      "Bạn có chắc muốn nâng cấp từ BASIC lên LIMITED không? Việc nâng cấp sẽ có hiệu lực ngay lập tức và các Pointment được xử lý trên nền tảng sẽ bị tính phí hoa hồng 10%.",
    limited_to_full_with_appointments:
      "Bạn có chắc muốn nâng cấp từ LIMITED lên FULL không? Các lượt nâng cấp lần đầu sẽ bắt đầu bản dùng thử MIỄN PHÍ 90 ngày của gói FULL. Các lượt nâng cấp lại sẽ bắt đầu chu kỳ thanh toán mới ngay sau khi nâng cấp.",
    limited_to_full_without_appointments:
      "Bạn có chắc muốn nâng cấp từ LIMITED lên FULL không? Các lượt nâng cấp lần đầu sẽ bắt đầu bản dùng thử MIỄN PHÍ 90 ngày của gói FULL. Các lượt nâng cấp lại sẽ bắt đầu chu kỳ thanh toán mới ngay sau khi nâng cấp.",
    limited_to_basic_with_appointments:
      "Bạn có chắc muốn hạ cấp từ LIMITED xuống BASIC không?",
    limited_to_basic_without_appointments:
      "Bạn có chắc muốn hạ cấp từ LIMITED xuống BASIC không?",
    full_to_limited_with_appointments:
      "Bạn có chắc muốn chuyển gói từ FULL xuống LIMITED không? Chu kỳ thanh toán hiện tại của bạn kết thúc vào [DATE]. Nếu hạ cấp gói hôm nay, bạn vẫn sẽ có toàn quyền truy cập cho đến hết kỳ thanh toán hiện tại. Sau [DATE], gói đăng ký của bạn sẽ được hạ cấp và bạn sẽ mất quyền truy cập vào lịch, dữ liệu cuộc hẹn trong tương lai và thông tin khách hàng. Các Pointment trên gói LIMITED sẽ bị tính phí hoa hồng 10%.",
    full_to_limited_without_appointments:
      "Bạn có chắc muốn chuyển gói từ FULL xuống LIMITED không? Chu kỳ thanh toán hiện tại của bạn kết thúc vào [DATE]. Nếu hạ cấp gói hôm nay, bạn vẫn sẽ có toàn quyền truy cập cho đến hết kỳ thanh toán hiện tại. Sau [DATE], gói đăng ký của bạn sẽ được hạ cấp và bạn sẽ mất quyền truy cập vào lịch, dữ liệu cuộc hẹn trong tương lai và thông tin khách hàng. Các Pointment trên gói LIMITED sẽ bị tính phí hoa hồng 10%.",
    full_to_basic_with_appointments:
      "Bạn có chắc muốn chuyển gói từ FULL xuống BASIC không? Chu kỳ thanh toán hiện tại của bạn kết thúc vào [DATE]. Nếu hạ cấp gói hôm nay, bạn vẫn sẽ có toàn quyền truy cập cho đến hết kỳ thanh toán hiện tại. Sau [DATE], gói đăng ký của bạn sẽ được hạ cấp và bạn sẽ mất quyền truy cập vào tất cả lịch, dữ liệu cuộc hẹn trong tương lai và thông tin khách hàng.",
    full_to_basic_without_appointments:
      "Bạn có chắc muốn chuyển gói từ FULL xuống BASIC không? Chu kỳ thanh toán hiện tại của bạn kết thúc vào [DATE]. Nếu hạ cấp gói hôm nay, bạn vẫn sẽ có toàn quyền truy cập cho đến hết kỳ thanh toán hiện tại. Sau [DATE], gói đăng ký của bạn sẽ được hạ cấp và bạn sẽ mất quyền truy cập vào tất cả lịch, dữ liệu cuộc hẹn trong tương lai và thông tin khách hàng.",
    basic_cancel_without_appointments:
      "Chu kỳ thanh toán hiện tại của bạn kết thúc vào [DATE]. Nếu bạn hủy hôm nay, bạn vẫn sẽ có toàn quyền truy cập cho đến hết kỳ thanh toán hiện tại. Sau [DATE], gói của bạn sẽ không gia hạn và quyền truy cập sẽ kết thúc. Bạn sẽ không còn hiển thị trên trang web hoặc ứng dụng Pointment. Bạn có chắc muốn hủy hôm nay không?",
    limited_cancel_with_appointments:
      "Bạn có chắc muốn hủy gói LIMITED không? Sau cuộc hẹn cuối cùng, bạn sẽ không còn quyền truy cập vào lịch hoặc hiển thị trên trang web hay ứng dụng Pointment nữa.",
    limited_cancel_without_appointments:
      "Bạn có chắc muốn hủy gói LIMITED không? Sau cuộc hẹn cuối cùng, bạn sẽ không còn quyền truy cập vào lịch hoặc hiển thị trên trang web hay ứng dụng Pointment nữa.",
    full_cancel_with_appointments:
      "Chu kỳ thanh toán hiện tại của bạn kết thúc vào [DATE]. Nếu bạn hủy hôm nay, bạn vẫn sẽ có toàn quyền truy cập cho đến hết kỳ thanh toán hiện tại. Sau [DATE], gói của bạn sẽ không gia hạn và quyền truy cập sẽ kết thúc. Bạn sẽ mất quyền hiển thị với tất cả lịch, dữ liệu cuộc hẹn trong tương lai và thông tin khách hàng. Bạn có chắc muốn hủy hôm nay không?",
    full_cancel_without_appointments:
      "Chu kỳ thanh toán hiện tại của bạn kết thúc vào [DATE]. Nếu bạn hủy hôm nay, bạn vẫn sẽ có toàn quyền truy cập cho đến hết kỳ thanh toán hiện tại. Sau [DATE], gói của bạn sẽ không gia hạn và quyền truy cập sẽ kết thúc. Bạn sẽ mất quyền hiển thị với tất cả lịch, dữ liệu cuộc hẹn trong tương lai và thông tin khách hàng. Bạn có chắc muốn hủy hôm nay không?",
    select_basic_plan_cc_info:
      "Vui lòng lưu ý rằng việc nhập thông tin thẻ tín dụng là bắt buộc đối với tất cả các tài khoản salon Pointment. Thẻ của bạn sẽ không bị trừ tiền cho đến khi tài khoản của bạn được Pointment xác minh và thời gian dùng thử miễn phí 60 ngày của bạn kết thúc. Bạn có thể hủy gói dịch vụ của mình bất cứ lúc nào.",
    select_limited_plan_cc_info:
      "Vui lòng lưu ý rằng việc nhập thông tin thẻ tín dụng là bắt buộc đối với các tài khoản salon Pointment khi chọn gói LIMITED, nhưng thẻ của bạn sẽ không bị trừ tiền. Phí 10% sẽ được thu cho tất cả các Pointment hoàn thành theo gói LIMITED. Khoản phí này sẽ được khấu trừ từ thu nhập của bạn trên Pointment.",
    select_full_plan_cc_info:
      "Vui lòng lưu ý rằng việc nhập thông tin thẻ tín dụng là bắt buộc đối với các tài khoản salon Pointment khi chọn gói FULL. Thẻ của bạn sẽ không bị trừ tiền cho đến khi tài khoản của bạn được Pointment xác minh và thời gian dùng thử miễn phí 90 ngày của bạn kết thúc. Bạn có thể hủy gói của mình bất cứ lúc nào.",
    choose_the_pointment_subscription_plan:
      "Hãy chọn gói đăng ký Pointment phù hợp nhất với doanh nghiệp của bạn. Bạn có thể nâng cấp, thay đổi hoặc hủy gói bất cứ lúc nào. Gói FULL bao gồm ba tháng đầu tiên miễn phí!",
    choose_the_pointment_subscription_plan_edit:
      "Hãy chọn gói đăng ký Pointment phù hợp nhất với doanh nghiệp của bạn. Bạn có thể nâng cấp, thay đổi hoặc hủy gói bất cứ lúc nào.",
    curious_how_each_plan_works_schedule_a_live:
      "Bạn có tò mò muốn xem cách mỗi gói hoạt động không? Hãy lên lịch một buổi",
    demo: "trình diễn trực tiếp",
    or_click: "hoặc nhấn",
    here: "vào đây",
    to_learn_more: "để tìm hiểu thêm",
    start_free_trial: "Bắt đầu dùng thử miễn phí",
    free_for: "Miễn phí",
    ninety_days: "90 ngày"
  },
  locations: {
    company: "Công ty",
    name: "Tên hiển thị",
    nickname: "Biệt danh",
    timezone: "Múi giờ",
    menu: "Thực đơn",
    amenities: "Tiện nghi",
    facebook_url: "Facebook URL",
    instagram_url: "Instagram URL",
    twitter_url: "Twitter URL",
    website_url: "Website URL",
    description: "Sự mô tả",
    cover_photo: "Ảnh bìa",
    current_cover_photo: "Ảnh bìa hiện tại",
    multi_person: "Nhiều người",
    hours: "Giờ",
    monday: "thứ hai",
    tuesday: "thứ ba",
    wednesday: "Thứ tư",
    thursday: "thứ năm",
    friday: "thứ sáu",
    saturday: "ngày thứ bảy",
    sunday: "chủ nhật",
    open: "mở",
    close: "gần",
    phone_number: "Số điện thoại",
    sms_phone_number: "Số điện thoại SMS",
    send_sms: "Gửi SMS",
    visible_on_homepage: "Hiển thị trên trang chủ",
    visible_on_homepage_helper: "(Công ty phải được xác minh bởi Pointment)",
    location_details: "Chi tiết vị trí",
    view_location_page: "Xem trang vị trí",
    address: "Địa chỉ"
  },
  platform: {
    contact_email: "Liên hệ Email",
    amount_billed_per_appointment: "Số tiền được thanh toán cho mỗi cuộc hẹn",
    service_price_per_month: "Giá dịch vụ hàng tháng",
    percent_billed_from_pos: "Phần trăm được thanh toán từ POS",
    appointment_reminder_hours_before: "Nhắc nhở cuộc hẹn giờ trước",
    approved_emails: "Email được phê duyệt",
    feature_flag_restricted_sign_up: "Đăng ký hạn chế",
    platform_settings: "Cài đặt nền tảng",
    platform_settings_details: "Chi tiết cài đặt nền tảng"
  },
  amenities: {
    name: "Tên",
    type: "Kiểu",
    logo_url: "Logo"
  },
  users: {
    first_name: "Họ",
    last_name: "Tên gia đình",
    profile_photo: "Ảnh hồ sơ",
    current_profile_photo: "Ảnh hồ sơ hiện tại",
    company: "Công ty",
    phone_number: "Số điện thoại",
    birthday: "Sinh nhật",
    stripe_customer_id: "ID khách hàng sọc",
    pronoun: "Đại từ",
    role: "Vai trò",
    customer: "Khách hàng",
    email: "Email",
    birthdate: "Ngày sinh",
    description: "Sự miêu tả",
    appointments: "Các cuộc hẹn",
    this_email_has_already_been_registered: "Email này đã được đăng ký.",
    registered: "Đăng ký",
    search: "Tìm kiếm",
    refunds: "Tín dụng",
    customer_details: "Chi tiết khách hàng",
    create_an_order: "Tạo đơn hàng",
    saved_credit_cards: "Thẻ tín dụng đã lưu",
    advanced_details: "Chi tiết nâng cao",
    no_credits: "Không có tín dụng",
    no_appointment_yet: "Chưa có cuộc hẹn nào",
    birthday_optional: "Sinh nhật (Tùy chọn)",
    has_logged_in: "Đã đăng nhập",
    resend_invite: "Không - Gửi lại lời mời",
    resend_invite_disabled: "Gửi lại lời mời",
    change_email_contact:
      "Để thay đổi email của bạn, vui lòng liên hệ với chúng tôi tại",
    notification_settings_title: "Cài đặt thông báo",
    promotional: "khuyến mãi",
    no_email: "Không có email",
    no_phone_number: "Không có số điện thoại",
    notification_email: "Email liên hệ",
    notification_sms: "SMS liên hệ",
    notification_promo_email: "Email khuyến mãi",
    notification_promo_sms: "SMS khuyến mãi",
    contact: "Liên hệ",
    on: "bật",
    off: "tắt"
  },
  availability: {
    title: "Tiêu đề",
    date: "Ngày",
    start: "Bắt đầu",
    end: "Chấm dứt",
    end_recurrence: "Kết thúc sự khả dụng định kỳ",
    location: "Địa điểm",
    artist: "Nghệ sĩ",
    event_type: "Loại sự kiện",
    event_type_availability: "khả dụng",
    repeat: "Tùy chọn lặp lại",
    delete_recurrence: "Xóa sự khả dụng định kỳ",
    new_availability: "Có sẵn mới",
    create_availability: "Tạo tình trạng sẵn có",
    edit_availability: "Chỉnh sửa phòng trống"
  },
  artists: {
    bio: "Sống",
    cover_photo: "Ảnh bìa",
    rating_aggregate: "Đánh giá tổng hợp",
    status: "Trạng thái",
    technicians: "Kỹ thuật viên",
    role: "Vai trò",
    exclude: "Loại trừ",
    artist_profile_photo: "Ảnh hồ sơ nghệ sĩ",
    create: "Tạo ra",
    artist_details: "Chi tiết nghệ sĩ",
    already_authorized_instagram_account:
      "Bạn đã ủy quyền tài khoản Instagram của mình.",
    active: "Hoạt động"
  },
  services: {
    name: "Tên",
    company: "Công ty",
    description: "Sự mô tả",
    duration: "Thời lượng",
    logo: "Biểu trưng",
    photo_1: "Ảnh 1",
    photo_2: "Ảnh 2",
    photo_3: "Ảnh 3",
    photo_4: "Ảnh 4",
    photo_5: "Ảnh 5",
    price: "Giá bán",
    special_conditions: "Điều kiện đặc biệt",
    facilities: "Thiết bị",
    menu_sections: "Các phần thực đơn",
    clean_up_time: "Thời gian dọn dẹp",
    category: "Thể loại",
    scheduling_priority: "Ưu tiên lên lịch",
    choice_is_required: "Yêu cầu lựa chọn",
    service_details: "Chi tiết dịch vụ",
    add_on_details: "Chi tiết tiện ích bổ sung",
    gallery_up_to_5_images: "Thư viện (tối đa 5 hình ảnh)",
    enable: "Cho phép",
    disable: "Vô hiệu hóa"
  },
  common: {
    name: "Tên",
    company: "Công ty",
    user: "Người dùng",
    description: "Sự mô tả",
    edit: "Sửa",
    show: "Trình diễn",
    export_to_csv: "Xuất sang CSV",
    select_date: "Chọn ngày",
    sort_by: "Sắp xếp theo",
    details: "chi tiết",
    more: "Hơn",
    add_ons: "Tiện ích bổ sung",
    cancellation_confirmation: "Xác nhận hủy",
    no_go_back: "Không, quay lại",
    yes_but_do_not_charge: "Có, nhưng không tính phí",
    yes_but_do_not_give_credits: "Có, nhưng không cung cấp tín dụng",
    yes: "Đúng",
    yes_cancel: "Có, hủy",
    created_at: "Được tạo lúc",
    updated_at: "Cập nhật lúc",
    no: "Không",
    view_details: "Xem chi tiết",
    locations: "Địa điểm",
    add_filters: "Thêm bộ lọc",
    reset_all: "Đặt lại tất cả",
    start_time: "Thời gian bắt đầu",
    end_time: "Thời gian kết thúc",
    "appointment.start_time": "Thời gian bắt đầu cuộc hẹn",
    all_locations: "Tất cả địa điểm",
    day_view: "Xem ngày",
    week_view: "Xem theo tuần",
    month_view: "Xem tháng",
    cancel: "Hủy bỏ",
    done: "Xong",
    today: "Hôm nay",
    last_week: "Tuần trước",
    this_week: "Tuần này",
    next_week: "Tuần tới",
    last_7_days: "7 ngày qua",
    next_7_days: "7 ngày tiếp theo",
    this_month: "Tháng này",
    next_month: "Tháng tiếp theo",
    clear_filters: "Xóa bộ lọc",
    save: "Lưu laị",
    saving: "Tiết kiệm",
    set_photo: "Đặt ảnh",
    please_wait: "Vui lòng chờ",
    we_are_loading_data: "Chúng tôi đang tải dữ liệu",
    remove: "Di dời",
    set_logo: "Đặt biểu tượng",
    set_image: "Đặt hình ảnh",
    undo: "Hoàn tác",
    something_went_wrong: "Đã xảy ra lỗi",
    delete: "Xóa bỏ"
  },
  cancellation_modal: {
    customer_already_paid: "Khách hàng đã thanh toán $%{amount}.",
    customer_not_paid_yet: "Khách hàng chưa thanh toán.",
    fee_will_be_charged:
      "Sau khi áp dụng phí hủy %{window} là $%{fee}, khách hàng sẽ bị tính phí $%{total}.",
    fee_will_be_credited_back:
      "Sau khi áp dụng phí hủy %{window} là $%{fee}, khách hàng sẽ được hoàn lại $%{credits}.",
    are_you_sure_to_cancel: "Bạn có chắc chắn muốn hủy không?",
    are_you_sure_to_cancel_appointment:
      "Bạn có chắc chắn muốn hủy cuộc hẹn này không?",
    late_cancelation_warning:
      "Yêu cầu hủy này nằm trong vòng 12 giờ trước thời gian bắt đầu cuộc hẹn. Bằng cách hủy, khách hàng vẫn phải thanh toán toàn bộ phí cuộc hẹn. Bạn có chắc chắn muốn hủy cuộc hẹn này không?",
    yes_waive_fees_refund: "Có, nhưng miễn phí và hoàn lại $%{amount}",
    fees_waived_refund_message:
      "Các khoản phí sẽ được miễn. Khách hàng sẽ được hoàn lại $%{amount}.",
    fee_applied_refund_message:
      "Sau khi áp dụng phí hủy %{window} là $%{fee}, khách hàng sẽ được hoàn lại $%{amount}.",
    will_refund_message: "Khách hàng sẽ được hoàn lại $%{amount}.",
    how_to_refund_explanation:
      "Bạn muốn hoàn tiền cho khách hàng như thế nào? Tín dụng cửa hàng được thêm vào ngay lập tức. Hoàn tiền về phương thức thanh toán ban đầu có thể mất 5–10 ngày làm việc.",
    refund_to_original_button:
      "Hoàn lại $%{amount} về phương thức thanh toán ban đầu",
    give_store_credits_button: "Cấp $%{amount} dưới dạng tín dụng cửa hàng",
    late_window: "trễ",
    no_show_window: "không đến"
  },
  menusections: {
    order: "Đặt hàng",
    section_name: "Tên phần",
    menu_details: "Chi tiết thực đơn",
    add_menu_section: "Thêm phần thực đơn"
  },
  appointmentservices: {
    name: "Tên",
    company: "Công ty",
    user: "Người dùng",
    person_number: "Số người",
    service: "Dịch vụ",
    order: "Đặt hàng",
    person_name: "Tên người",
    appointment: "Cuộc hẹn",
    artist: "Nghệ sĩ"
  },
  appointment: {
    user: "Người dùngr",
    customer: "Khách hàng",
    inserted_by: "Được chèn bởi",
    start_time: "bắt đầu",
    end_time: "kết thúc",
    location: "Địa điểm",
    service: "Dịch vụ",
    services: "Dịch vụ",
    location_name: "Tên địa điểm",
    created_at: "Được tạo lúc",
    updated_at: "Cập nhật lúc",
    checked_in_at: "Đã check-in tại",
    confirmed_at: "Đã xác nhận tại",
    cancelled_at: "Đã hủy tại",
    appointment_services: "Dịch vụ cuộc hẹn",
    notes: "Ghi chú",
    check_in: "Kiểm tra",
    check_out: "Kiểm tra",
    services_completed: "Dịch vụ đã hoàn thành",
    cancel: "Hủy bỏ",
    completed_at: "Đã hoàn thành tại",
    charge: "Phí",
    artists: "Nghệ sĩ",
    rescheduled_at: "Đã lên lịch lại tại",
    today: "Hôm nay",
    checked_in: "Đi vào",
    order: "Đặt hàng",
    start_end_time: "Thời gian bắt đầu và kết thúc",
    cancelled: "Đã hủy",
    reschedule: "Sắp xếp lại",
    order_details: "Chi tiết đặt hàng",
    checked_out: "Đã trả phòng",
    appointment_details: "Chi tiết cuộc hẹn",
    log: "Nhật ký",
    date: "Ngày",
    persons: "Người",
    status: "Trạng thái",
    in_progress: "Trong tiến trình",
    upcoming: "Sắp tới",
    completed: "Hoàn thành",
    rescheduled: "Đã lên lịch lại",
    time: "Thời gian",
    client: "Khách hàng",
    note: "Ghi chú",
    appointment_note: "Giấy hẹn",
    service_and_add_ons: "Dịch vụ và tiện ích bổ sung",
    start_date_and_time: "Ngày và giờ bắt đầu",
    create_pointment: "Tạo cuộc hẹn",
    select_customer: "Chọn khách hàng",
    customers: "Khách hàng",
    search_by_phone: "Tìm kiếm theo số",
    new_customer: "Khách hàng mới",
    search: "Tìm kiếm",
    general_details: "Chi tiết chung",
    select_services: "Chọn dịch vụ",
    section: "Phần",
    addons: "Tiện ích bổ sung",
    add: "Thêm",
    added: "Đã thêm",
    total_price: "Tổng giá",
    total_duration: "Tổng thời lượng",
    please_select_the_location_first:
      "Vui lòng chọn vị trí trước trong phần thông tin chi tiết chung",
    you_need_to_fill_required_fields: "Bạn cần điền vào các trường bắt buộc",
    no_existing_customer_found:
      "Không tìm thấy khách hàng hiện tại có số tìm kiếm",
    existing_customer_selected:
      "%{name} đã tồn tại với số điện thoại này và đã được chọn",
    at_least_one_service: "Ít nhất một dịch vụ phải được chọn",
    got_it: "Đã hiểu",
    fees_not_included: "Phí không bao gồm",
    clean_up_time_not_included: "Thời gian dọn dẹp không bao gồm",
    search_to_find_customers: "Tìm kiếm để tìm khách hàng",
    blocked_time: "Thời gian bị chặn",
    client_phone_number: "Số điện thoại khách hàng",
    cancel_full_appointment: "Hủy toàn bộ cuộc hẹn",
    client_details: "Chi tiết khách hàng",
    this_artist_was_specified_by_customer:
      "Nghệ sĩ này được khách hàng chỉ định",
    moved_at: "Đã chuyển tại"
  },
  facility: {
    name: "Tên",
    capacity: "Sức chứa",
    location: "Địa điểm",
    services: "Dịch vụ",
    facility_services: "Dịch vụ thiết bị"
  },
  order: {
    user: "Người dùng",
    appointment: "Cuộc hẹn",
    artist: "Nghệ sĩ",
    status: "Trạng thái",
    created_at: "Được tạo lúc",
    updated_at: "Cập nhật lúc",
    amount: "Số tiền",
    refunded_at: "Được hoàn tiền tại",
    transactions: "Giao dịch",
    tx_services: "Dịch vụ giao dịch",
    finsh_order: "Đơn đặt hàng hoàn thành",
    tip_amount: "Số tiền gợi ý",
    final_amount: "Số tiền cuối cùng",
    amount_captured: "Số tiền bị bắt",
    tips_captured: "Lời khuyên đã được ghi lại",
    payment_status: "Trạng thái thanh toán",
    charge: "Thù lao",
    add_to_order: "Thêm để đặt hàng",
    create_order: "Tạo đơn hàng",
    export_to_pdf: "Xuất đơn hàng sang .PDF",
    refund: "Đền bù",
    refunded: "Hoàn lại tiền",
    refund_funds: "Hoàn tiền",
    maximum_refundable: "Số tiền hoàn tối đa",
    refund_amount_exceeds_max: "Số tiền vượt quá số tiền hoàn tối đa",
    refund_amount_load_error: "Không tải được số tiền có thể hoàn",
    refund_submit_error: "Không hoàn tiền được giao dịch",
    refund_success: "Đã hoàn tiền",
    cancel: "Hủy bỏ",
    cancelled: "Đã hủy",
    order_details: "Chi tiết đặt hàng",
    item: "Mục",
    price: "Giá",
    quantity: "Số lượng",
    method: "Phương pháp",
    type: "Kiểu",
    tips: "Lời khuyên",
    what_to_add: "Thêm gì",
    description: "Sự mô tả",
    services: "Dịch vụ",
    service: "Dịch vụ",
    addon: "Thêm vào",
    freeform: "Hình thức tự do",
    locations: "Địa điểm",
    location: "Địa điểm",
    add_arbitary_credits: "Hoàn tiền tín dụng",
    where_to_add: "Thêm vào đâu",
    subtotal: "Tổng phụ",
    tax_and_fees: "Thuế & Phí",
    discount: "Giảm giá",
    total: "Tổng cộng",
    add_service: "Thêm dịch vụ",
    add_add_on: "Thêm tiện ích bổ sung",
    add_freeform: "Thêm biểu mẫu miễn phí",
    add_discount: "Thêm giảm giá",
    edit_order: "Chỉnh sửa đơn hàng",
    walk_in: "Đi bộ",
    amount_required: "Cần số tiền",
    total_amount: "Tổng số tiền",
    tip: "Tiền tip"
  },
  empty_list: {
    do_you_want_to_add_one: "Bạn có muốn thêm một?",
    no_customers_yet: "Chưa có khách hàng.",
    add_a_customer: "Thêm một khách hàng",
    no_appointments_yet: "Chưa có cuộc hẹn nào.",
    no_appointments_were_found: "Không có cuộc hẹn nào được tìm thấy.",
    no_orders_yet: "Chưa có đơn hàng nào.",
    no_equipment_yet: "Chưa có thiết bị.",
    add_an_equipment: "Thêm một thiết bị",
    no_menus_yet: "Chưa có thực đơn nào.",
    add_a_menu: "thêm thực đơn",
    no_services_yet: "Chưa có dịch vụ nào.",
    no_addons_yet: "Chưa có thêm vào.",
    add_a_service: "Thêm một dịch vụ",
    add_a_addon: "Thêm một add on",
    no_locations_yet: "Chưa có địa điểm nào.",
    add_a_location: "Thêm một địa điểm",
    no_staff_members_yet: "Chưa có nhân viên nào.",
    add_a_member: "thêm một thành viên",
    no_artists_yet: "Chưa có nghệ sĩ nào.",
    no_results_found: "Không tìm thấy kết quả nào vào ngày này."
  },
  navigation: {
    Dashboard: "Đồ để phủ",
    Schedule: "Lịch trình",
    Customers: "Khách hàng",
    Users: "Người dùng",
    System: "Hệ thống",
    Charge: "Thù lao",
    Staff: "Nhân viên",
    Salon: "Thẩm mỹ viện",
    Availability: "Khả dụng",
    Appointment: "Cuộc hẹn",
    appointment_calendar: "Lịch hẹn",
    services_calendar: "Lịch dịch vụ",
    Companies: "Các công ty",
    platform_settings: "Cài đặt nền tảng",
    appointment_orders: "Đặt hàng cuộc hẹn",
    walk_in_orders: "Đặt hàng bước vào",
    "Appointment Services": "Dịch vụ cuộc hẹn",
    Reporting: "Báo cáo",
    Tipping: "Gợi ý",
    Orders: "Đơn hàng",
    Transactions: "Giao dịch",
    "Cancelled Appointments": "Cuộc hẹn bị hủy",
    Company: "Công ty",
    Location: "Vị trí",
    Menus: "Thực đơn",
    Services: "Dịch vụ",
    AddOns: "Thêm vào",
    Equipment: "Thiết bị",
    Support: "Ủng hộ",
    Version: "Phiên bản",
    log_out: "Đăng xuất",
    English: "Tiếng Anh",
    Vietnamese: "Tiếng Việt",
    new_charge: "Phí mới"
  },
  refund: {
    amount: "Số tiền",
    consumed: "Tiêu thụ",
    not_consumed: "Không tiêu thụ",
    appointment: "Cuộc hẹn",
    take_away: "Mang đi"
  },
  report: {
    appointment_services: "Dịch vụ cuộc hẹn",
    date: "Ngày",
    time: "Thời gian",
    artist: "Nghệ sĩ",
    service: "Dịch vụ",
    customer_name: "Tên khách hàng",
    location: "Địa điểm",
    amount: "Số tiền",
    is_fully_paid: "Đã thanh toán đầy đủ",
    order_id: "ID đơn hàng",
    artist_name: "Tên nghệ sĩ",
    artist_id: "ID nghệ sĩ",
    appointment_date: "Ngày cuộc hẹn",
    appointment_description: "Mô tả cuộc hẹn",
    tip_amount: "Số tiền gợi ý",
    tipping: "Gợi ý",
    transactions: "Giao dịch",
    cancelled_appointments: "Cuộc hẹn bị hủy",
    appointment_id: "ID cuộc hẹn",
    location_id: "ID địa điểm",
    cancelled_at: "Đã hủy tại",
    was_rescheduled: "Đã lên lịch lại",
    cancellation_type: "Loại hủy",
    transaction_id: "ID giao dịch",
    transaction_type: "Loại giao dịch",
    transaction_refund_capture: "Giao dịch hoàn tiền bắt",
    transaction_date_time: "Ngày giờ giao dịch",
    transaction_tip_amount: "Số tiền gợi ý giao dịch",
    transaction_services_total: "Tổng số dịch vụ giao dịch",
    transaction_user_pays_fees: "Người dùng trả phí",
    transaction_payment_fees_percent: "Phần trăm phí thanh toán",
    transaction_payment_fees: "Phí thanh toán",
    transaction_total: "Tổng cộng giao dịch",
    location_name: "Tên địa điểm",
    stripe_id: "ID sọc",
    status: "Trạng thái",
    transaction_description: "Mô tả giao dịch",
    appointment_date_time: "Ngày giờ cuộc hẹn",
    total: "Toàn bộ",
    payout: "Thanh toán",
    cc_payout: "Thanh toán thẻ tín dụng"
  },
  dashboard: {
    dashboard: "Bảng điều khiển",
    no_data_yet: "Chưa có dữ liệu",
    sales: "Doanh thu",
    services: "Dịch vụ",
    tips: "Tiền tip",
    customers: "Khách hàng",
    new: "Mới",
    recurring: "Định kỳ",
    completed: "Đã hoàn thành",
    upcoming: "Sắp tới",
    customer: "Khách hàng",
    service: "Dịch vụ",
    artist: "Nghệ sĩ",
    starts: "Bắt đầu",
    you: "Bạn",
    today: "Hôm nay",
    total: "Tổng"
  }
};
